import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const GasElectricIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-gasElectric"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M54,34 L14,34 L14,33 C14,31.895 14.895,31 16,31 L52,31 C53.105,31 54,31.895 54,33 L54,34 Z"
          fill="#00000"
          className={styles.defaultColor}
        />
        <polygon fill="#00000" className={styles.defaultColor} points="17 31 19 31 19 27 17 27" />
        <polygon fill="#00000" className={styles.defaultColor} points="33 31 35 31 35 27 33 27" />
        <polygon fill="#00000" className={styles.defaultColor} points="49 32 51 32 51 27 49 27" />
        <polygon fill="#00000" className={styles.defaultColor} points="17 28 27 28 27 26 17 26" />
        <polygon fill="#00000" className={styles.defaultColor} points="41 28 51 28 51 26 41 26" />
        <path
          d="M57.222 7 51.149 7C51.13 7 51.116 6.982 51.121 6.964L53.2.036C53.205.018 53.191 0 53.172 0L48.341 0C48.329 0 48.318.008 48.314.02L44.431 12.964C44.426 12.982 44.439 13 44.458 13L49.008 13C49.026 13 49.04 13.018 49.035 13.035L46.65 22.18C46.642 22.21 46.682 22.229 46.7 22.203L57.245 7.044C57.258 7.026 57.245 7 57.222 7M10.778 7 16.851 7C16.87 7 16.884 6.982 16.879 6.964L14.8.036C14.795.018 14.809 0 14.828 0L19.659 0C19.671 0 19.682.008 19.686.02L23.569 12.964C23.574 12.982 23.561 13 23.542 13L18.992 13C18.974 13 18.96 13.018 18.965 13.035L21.35 22.18C21.358 22.21 21.318 22.229 21.3 22.203L10.755 7.044C10.742 7.026 10.755 7 10.778 7"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M39.4321022,10.9636504 L34.0129859,0.916539016 L28.2430646,11.3113778 C27.4714986,13.0077199 27.0151935,15.3818333 27.000427,17.3923556 L27.0021194,17.782926 C27.003214,17.8408251 27.0047401,17.8955155 27.0067353,17.9475807 L27.0246388,18.2331415 C27.0326846,18.3209415 27.0429092,18.4029111 27.0556145,18.4837204 L27.1066171,18.7520112 L27.1408323,18.9053989 C27.9432537,22.4474042 30.7383362,24.9997 34.0234,24.9997 C37.1141189,24.9997 39.7865095,22.7393667 40.7539034,19.486781 C40.8532373,19.1531212 40.9202661,18.7255134 40.9602741,18.2207063 C41.1582737,15.7314175 40.6095915,13.1868122 39.4321022,10.9636504 Z M30.0284037,12.2090981 L33.987,5.082 L37.6682643,11.9064222 C38.666926,13.7920092 39.1339438,15.9578823 38.9665484,18.0624098 C38.9366503,18.4396527 38.8896726,18.7393455 38.8369717,18.9163664 C38.1089046,21.3642839 36.1753532,22.9997 34.0234,22.9997 C31.7319703,22.9997 29.6983699,21.1427424 29.0916861,18.4647542 L29.0418359,18.2335241 L29.0210568,18.0963459 C29.0182232,18.0716911 29.015696,18.0457943 29.0134624,18.0181363 L29.003481,17.8268997 L28.9999073,17.5684704 C28.9999073,17.5184149 28.9999073,17.4645212 29.0003784,17.4062702 C29.0131998,15.6606284 29.4169933,13.5597279 30.0284037,12.2090981 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M31.5587,14.3437 C31.2047,15.1967 31.0067,16.4347 31.0007,17.3997 C30.9977,17.8147 31.0157,17.8977 31.0587,18.1017 C31.4047,19.7697 32.5957,20.9997 34.0117,20.9997 C35.3467,20.9997 36.4827,19.9067 36.8977,18.3827 C36.9367,18.2397 36.9647,18.0387 36.9817,17.8047 C37.0757,16.5227 36.8057,15.2397 36.2737,14.1447 L33.9997,8.9997 L31.5587,14.3437 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
